import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import Copyright from '../../commons/Copyright';
import styled from "styled-components";
import Card from '@mui/material/Card';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { userService } from '../../../services';
import { useHistory } from "react-router-dom";
import { Container } from '@mui/material';
import HeaderPublic from '../../commons/HeaderPublic';
import { isNotLoginLogin } from '../../../utils/session';

const moment = require("moment");

export default function MiSuscripcion(props) {
    const { t, i18n } = useTranslation();
    const [suscription,setSuscription] = useState<any>(null)
    const [finishSuscription,setFinishSuscription] = useState<any>(null)
    const [active,setActive] = useState(false)
    const [loaded,setLoaded] = useState(false)
    let history = useHistory()

    useEffect(()=>{
        if(isNotLoginLogin()){
            history.push("/acceso");
            return;
        }
        userService.mysuscription((data, error) => {
            if (data && data.data){
                setSuscription(data.data.suscription ? data.data.suscription : null);
                setFinishSuscription(data.data.finishSuscription ? data.data.finishSuscription : null);
                setActive(!!data.data.active);
            }
            setLoaded(true);
        });
    },[]);

    const goBack = () => {
        window.location.href = process.env.REACT_APP_PROTECMEDIA + "";
    }

    return (<Main>
            <Container>
            <HeaderPublic style={{margin: "1em 0"}}/>
            <CardLongin>
                <Typography variant="body1" align="center" style={{fontWeight:"bold"}}>Mi suscripción</Typography>
                {loaded && !suscription &&
                    <>
                        <Typography variant="body2" color="textSecondary" align="center" style={{margin:"1em 0"}}>No tienes ninguna suscripción activa</Typography>
                        <ButtonForm variant="contained" color="primary" href="/suscripciones">Ver suscripciones disponibles</ButtonForm>
                    </>
                }
                {loaded && suscription &&
                    <SuscriptionBox>
                        <p><b>Plan:</b> {suscription.name}</p>
                        <p><b>Precio:</b> {suscription.price} €</p>
                        <p><b>Fecha fin:</b> {finishSuscription ? moment(finishSuscription).format('DD/MM/YYYY') : "-"}</p>
                        <p><b>Estado:</b> <StateBadge active={active}>{active ? "Activa" : "Caducada"}</StateBadge></p>
                    </SuscriptionBox>
                }
                <ButtonForm variant="outlined" color="primary" onClick={goBack} style={{marginBottom: "20px",marginTop: "20px",}}>Volver</ButtonForm>
                <Copyright />
            </CardLongin>
            </Container>
            </Main>

      );

}

const CardLongin = styled(Card)`
    padding: 1em;
    text-align: center;
    display: flex;
    flex-direction: column;
    align-items: center;
`;

const ButtonForm = styled(Button)`
    margin-top: 20px;
    margin-bottom: 20px;
`;

const Main = styled.div`
    background-repeat:no-repeat;
    background-size:cover;
    background-position:center;
    width: 100%;
    height: 100vh;
    display: flex;
`;

const SuscriptionBox = styled.div`
    width: 100%;
    max-width: 400px;
    text-align: left;
    margin: 1em 0;

    & p {
        margin: 0.5em 0;
    }
`;

const StateBadge = styled.span<{active: boolean}>`
    display: inline-block;
    padding: 0.2em 0.8em;
    border-radius: 12px;
    color: white;
    background: ${props => props.active ? "darkgreen" : "darkred"};
`;
